<template>
  <a-card :bordered="false" title="数据统计">
    <search-page-view
      :col="2"
      ref="pageList"
      :itemNames="['s1','s2','s3']"
      :columns="getColumns()"
      :show-reset-button="true"
      :queryParams="queryParams"
      :leftSpace="10"
      :requestPromise="getTaskList"
      @reset="onRestEvent"
    >
      <a-form-item slot="s1" label="分销员ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.staffId " placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.staffName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="手机" v-bind="searchItemLayout">
        <a-input v-model="queryParams.staffMobile" placeholder="请输入"></a-input>
      </a-form-item>
      <div slot="operation" style="height: 40px">
        <span style="float: right">
        <span>设置</span>
          <a style="margin-left: 10px" @click="addEvent">打卡任务</a>
        </span>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'

export default {
  name: 'DailyAttendanceStatistics',
  mixins: [salesTaskMixins],
  data() {
    return {
      queryParams: {}
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getColumns() {
      return [
        {
          title: '分销员ID',
          dataIndex: 'staffId'
        },
        {
          title: '店铺名称',
          dataIndex: 'staffShopName'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '手机号',
          dataIndex: 'staffMobile'
        },
        {
          title: '红包（元）',
          dataIndex: 'redPacketAmount'
        },
        {
          title: '连续签到（天）',
          dataIndex: 'consecutiveDayNumber'
        },
        {
          title: '打卡时间',
          dataIndex: 'clockTime'
        }
      ]
    },
    getTaskList(params) {
      return this.getHttpServices().getUserService().post('merchant/v2/clock/findStaffClockRecords', params)
    },

    addEvent() {
      let pageParams = this.getPageParams()
      this.openNewPage('DailyAttendance', { ...pageParams })
    },
    onRestEvent() {
      this.queryParams = {}
    }
  }

}
</script>
<style scoped>
</style>